import React from "react";
import { useParams } from "react-router-dom";
import DefaultLayout from "app/layouts/DefaultLayout";
import Recommend from "app/components/Recommend";

function RecommendCreatePage(props) {
  const { stepId } = useParams();

  return (
    <DefaultLayout
      headerProps={{
        headerClassName: "md:!block",
        pageTitle: "検査データ新規登録",
      }}
      showNotice={false}
    >
      <Recommend.Form stepId={+stepId} />
    </DefaultLayout>
  );
}

export default RecommendCreatePage;
